export default __webpack_public_path__ + "static/media/calibration-logo.29e2e329.png";